// extracted by mini-css-extract-plugin
export var expandedRowWrapper = "_5h-6";
export var headerCell = "_5h-2";
export var rowWrapper = "_5h-4";
export var stickyAggregationCell = "_5h-a";
export var stickyAggregationRow = "_5h-7";
export var stickyColumnCell = "_5h-9";
export var stickyColumnHeaderCell = "_5h-8";
export var table = "_5h-1";
export var virtualRowWrapper = "_5h-5";
export var virtualTableContainer = "_5h-0";
export var white = "_5h-3";